import Controller from '@ember/controller';
import { get } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import logger from 'donor-elf-web/lib/logger';
import moment from 'moment';

export default Controller.extend({
  cookies: service(),
  currentUser: service(),
  router: service(),
  session: service(),

  roleOptions: [
    {
      label: 'Missionary',
      val: 1,
    },
    {
      label: 'Director of Operations / Finance',
      val: 2,
    },
    {
      label: 'Director of Development',
      val: 3,
    },
    {
      label: 'Other',
      val: 4,
    },
  ],

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        yield changeset.save();
      } catch (error) {
        logger.error(error);
      }
      let demoEmail = get(changeset, 'email');
      if (isEmpty(demoEmail)) {
        demoEmail = 'blank';
      }
      let twoYears = moment().add(2, 'years').toDate();
      this.cookies.write('demo_email', demoEmail, { expires: twoYears });
      yield this.session.authenticate(
        'authenticator:oauth2',
        'demo@donorelf.com',
        'password',
      );
      yield this.currentUser.load();
      this.router.transitionTo('funds.fund', 'selected-fund');
    }
  }).drop(),
});
